<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit College">
      <div class="row">
        <div class="col-md-6 form-group">
          College Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = false"/>
          <div v-if="nameEmpty" style="color: red">
            College name is required
          </div>
        </div>        
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="editCollege()">
          Save
        </b-button>
      </div>

      <!-- Page Content -->
      <div class="">
      <!-- Full Table -->
        <base-block rounded title="College Admin List">       
          <div class="row">
            <!-- Director Modal -->
            <div class="col-md-6 form-group">
              <b-modal
                id="modal-1"
                title="Add Director"
                size="lg"
                ref="modalone"
                no-close-on-esc
                no-close-on-backdrop
                hide-header-close
                hide-footer>
                <div class="row">
                  <div class="col-md-6 form-group">
                    User Name
                    <input
                      class="form-control"
                      v-model="topicName"
                      @focus="topicEmpty = false"/>
                    <div class="form-group" style="color: red" v-if="topicEmpty">
                      Username is required
                    </div>
                  </div>

                  <div class="col-md-6 form-group" style="position: relative">
                    Password
                    <input
                      id="password"
                      type="password"
                      class="form-control"
                      v-model="password"
                      @focus="passwordEmpty = false"/>
                    <i class="far fa-eye" @click="togglePassword()" id="eyeIcon" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                    <div v-if="passwordEmpty" style="color: red">
                      Password is required
                    </div>
                  </div>

                  <div class="col-md-6 form-group" style="position: relative">
                    Confirm Password
                    <input
                      id="password1"
                      type="password"
                      class="form-control"
                      v-model="confirmpassword"
                      @focus="confirmpasswordEmpty = false,
                      confirmpasswordMatch = false"/>
                    <i class="far fa-eye" @click="togglePassword1()" id="eyeIcon1" 
                      style="position: relative;bottom: 28px;right: 0px;left: 330px;">
                    </i>
                    <div v-if="confirmpasswordEmpty" style="color: red">
                      Confirm Password is required
                    </div>
                    <div v-if="confirmpasswordMatch" style="color: red">
                      Password does not match 
                    </div>
                  </div>

                  <div class="col-md-12">
                    <b-button
                      @click="addParentData()"
                      variant="success"
                      class="float-right ml-4">Insert
                    </b-button>
                    <b-button
                      @click="cancelButtonParentData()"
                      variant="danger"
                      class="float-right">Cancel
                    </b-button>
                  </div>
                </div>                
              </b-modal>
              <!-- Director edit modal -->
              <b-modal
                id="modal-3"
                title="Edit Director"
                size="lg"
                ref="modalthree"
                no-close-on-esc
                no-close-on-backdrop
                hide-header-close
                hide-footer>
                <div class="row">
                  <div class="col-md-6 form-group">
                    Director
                    <input
                      class="form-control"
                      @focus="parentTopicEmpty = false"
                      v-model="parentLibraryName"
                    />
                    <div
                      class="form-group"
                      style="color: red"
                      v-if="parentTopicEmpty"
                    >
                      Director is required
                    </div>
                  </div>                

                  <div class="col-md-6 form-group" style="position: relative">
                    Password
                    <div>
                    <input
                      id="password"
                      type="password"
                      class="form-control"
                      v-model="password"
                      @focus="passwordEmpty = false"
                    />
                    <i class="far fa-eye" @click="togglePassword()" id="eyeIcon" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                    </div>
                    <div v-if="passwordEmpty" style="color: red">
                      Password is required
                    </div>
                  </div>
                  <div class="col-md-6 form-group" style="position: relative">
                    Confirm Password
                    <input
                      id="password1"
                      type="password"
                      class="form-control"
                      v-model="confirmpassword"
                      @focus="confirmpasswordEmpty = false,confirmpasswordMatch = false"
                    />
                    <i class="far fa-eye" @click="togglePassword1()" id="eyeIcon1" style="position: relative;bottom: 28px;right: 0px;left: 330px;">
                    </i>
                    <div v-if="confirmpasswordEmpty" style="color: red">
                      Confirm Password is required
                    </div>
                    <div v-if="confirmpasswordMatch" style="color: red">
                      Password does not match 
                    </div>
                  </div>
                </div>

                <div>
                  <b-button
                    @click="editParentTopics()"
                    variant="success"
                    class="float-right ml-2"
                    >Save Changes</b-button
                  >
                  <b-button
                    variant="danger"
                    class="float-right"
                    @click="editCancelButtonParentLibrary"
                    >Cancel</b-button
                  >
                </div>
              </b-modal>

              <!-- Director list -->
              
                <b-list-group v-if="college_director === null">
                  Director
                  <b-list-group-item
                    id="addParentTopicButton"
                    v-b-modal.modal-1
                    class="mb-1"
                    button> + Add Director
                  </b-list-group-item>
                </b-list-group>
                <b-list-group v-else>
                  Director
                  <div style="max-height: 280px; overflow-y: scroll">
                    <b-list-group-item
                      >{{ college_director.username }}
                      <b-btn-group class="float-right">
                        <b-button
                          size="sm"
                          variant="alt-primary"
                          v-b-modal.modal-3
                          @click="loadParentTopic(college_director.id)"
                        >
                          <i class="fa fa-fw fa-pencil-alt"></i>
                        </b-button>
                      
                        <b-button
                          size="sm"
                          variant="alt-primary"
                          @click="
                          getDepartments(college_director.id)"
                        >
                          <i class="fa fa-fw fa-angle-right"></i>
                        </b-button>
                      </b-btn-group>                 
                    </b-list-group-item>
                  </div>
                </b-list-group>
              </div>

            <!-- Department List-->
              <div class="col-md-6 form-group">
                <b-list-group v-if="addlibraryButton && $store.getters.userDetails.includes('CAN_ADD_LIBRARY')">
                  Department
                  <b-list-group-item
                    id="addLibraryButton"
                    v-b-modal.modal-2
                    class="mb-1"
                    button
                    >+ Add Department</b-list-group-item
                  ></b-list-group
                >
                <div style="max-height: 280px; overflow-y: scroll">
                  <b-list-group
                    v-for="(collge_admin, index) in collge_admins"
                    :key="index"
                    class="mb-1"
                  >
                    <b-list-group-item
                      >{{ collge_admin.username}}
                      <b-btn-group class="float-right"
                        ><b-button v-if="$store.getters.userDetails.includes('CAN_EDIT_LIBRARY')"
                          size="sm"
                          variant="alt-primary"
                          @click="loadLibrary(collge_admin.id)"
                          v-b-modal.modal-4
                        >
                          <i class="fa fa-fw fa-pencil-alt"></i>
                        </b-button>                   
                      
                        <b-button
                          size="sm"
                          variant="alt-primary"
                          @click="
                          getHods(collge_admin.id)"
                        >
                          <i class="fa fa-fw fa-angle-right"></i>
                        </b-button>
                      </b-btn-group>
                    </b-list-group-item>
                  </b-list-group>
                </div>    
                  <!-- Department Modal -->
                  <b-modal
                    id="modal-2"
                    ref="modaltwo"
                    title="Add Department"
                    size="lg"
                    no-close-on-esc
                    no-close-on-backdrop
                    hide-header-close
                    hide-footer
                    >                  
                    <div class="row">
                      <div class="col-md-6 form-group">
                        User Name
                        <input
                          class="form-control"
                          v-model="departmentName"
                          @focus="departmentNameEmpty = false"
                        />
                        <div class="form-group" style="color: red" v-if="departmentNameEmpty">
                          Username is required
                        </div>
                      </div>

                      <div class="col-md-6 form-group" style="position: relative">
                        Password
                        <input
                          id="password"
                          type="password"
                          class="form-control"
                          v-model="departmentPassword"
                          @focus="departmentPasswordEmpty = false"
                        />
                        <i class="far fa-eye" @click="togglePassword()" id="eyeIcon" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                        <div v-if="departmentPasswordEmpty" style="color: red">
                          Password is required
                        </div>
                      </div>
                      <div class="col-md-6 form-group" style="position: relative">
                        Confirm Password
                          <input
                            id="password1"
                            type="password"
                            class="form-control"
                            v-model="departmentConfirmPassword"
                            @focus="departmentConfirmPasswordEmpty = false,departmentConfirmPasswordMatch = false"
                          />
                          <i class="far fa-eye" @click="togglePassword1()" id="eyeIcon1" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                          <div v-if="departmentConfirmPasswordEmpty" style="color: red">
                            Confirm Password is required
                          </div>
                          <div v-if="departmentConfirmPasswordMatch" style="color: red">
                            Password does not match 
                          </div>
                      </div>
                    </div>
                      <b-button
                        @click="addDepartment()"
                        variant="success"
                        class="float-right ml-2"
                        >Insert</b-button
                      >
                      <b-button
                        @click="cancelButtonDepartment()"
                        variant="danger"
                        class="float-right"
                        >Cancel</b-button
                      >
                  </b-modal>

                  <!-- Department edit modal -->
                  <b-modal
                    id="modal-4"
                    ref="modalfour"
                    title="Edit Department"
                    size="lg"
                    no-close-on-esc
                    no-close-on-backdrop
                    hide-header-close
                    hide-footer
                  >
                    <div class="row">
                      <div class="col-md-6 form-group">
                        Usernme
                        <input
                          class="form-control"
                          v-model="libraryName"
                          @focus="libraryNameEmpty = false"
                        />
                        <div
                          class="form-group"
                          style="color: red"
                          v-if="libraryNameEmpty"
                        >
                          Username is required
                        </div>
                      </div>
                      

                      <div class="col-md-6 form-group" style="position: relative">
                        Password
                        <input
                          id="password"
                          type="password"
                          class="form-control"
                          v-model="departmentPassword"
                          @focus="departmentPasswordEmpty = false"
                        />
                        <i class="far fa-eye" @click="togglePassword()" id="eyeIcon" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                        <div v-if="departmentPasswordEmpty" style="color: red">
                          Password is required
                        </div>
                      </div>
                      <div class="col-md-6 form-group" style="position: relative">
                        Confirm Password
                          <input
                            id="password1"
                            type="password"
                            class="form-control"
                            v-model="departmentConfirmPassword"
                            @focus="departmentConfirmPasswordEmpty = false,departmentConfirmPasswordMatch = false"
                          />
                          <i class="far fa-eye" @click="togglePassword1()" id="eyeIcon1" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                          <div v-if="departmentConfirmPasswordEmpty" style="color: red">
                            Confirm Password is required
                          </div>
                          <div v-if="departmentConfirmPasswordMatch" style="color: red">
                            Password does not match 
                          </div>
                        </div>

                    </div>
                    <div>
                      <b-button
                        @click="editLibrary()"
                        variant="success"
                        class="float-right ml-2"
                        >Save changes</b-button
                      >
                      <b-button
                        variant="danger"
                        class="float-right"
                        @click="editLibraryCancelButton()"
                        >Cancel</b-button
                      >
                    </div>
                  </b-modal>
                </div>



            <!-- Hod List-->
              <div class="col-md-6 form-group">
                <b-list-group v-if="addHodButton && $store.getters.userDetails.includes('CAN_ADD_LIBRARY')">
                  Hod
                  <b-list-group-item
                    id="addHodButton"
                    v-b-modal.modal-5
                    class="mb-1"
                    button
                    >+ Add Hod</b-list-group-item
                  ></b-list-group
                >
                <div style="max-height: 280px; overflow-y: scroll">
                  <b-list-group
                    v-for="(collge_admin, index) in collge_admin_hods"
                    :key="index"
                    class="mb-1"
                  >
                    <b-list-group-item
                      >{{ collge_admin.username}}
                      <b-btn-group class="float-right"
                        ><b-button v-if="$store.getters.userDetails.includes('CAN_EDIT_LIBRARY')"
                          size="sm"
                          variant="alt-primary"
                          @click="loadHod(collge_admin.id)"
                          v-b-modal.modal-6
                        >
                          <i class="fa fa-fw fa-pencil-alt"></i>
                        </b-button>                   
                      
                        <b-button
                          size="sm"
                          variant="alt-primary"
                          @click="getClass(collge_admin.id)"
                        >
                          <i class="fa fa-fw fa-angle-right"></i>
                        </b-button>
                      </b-btn-group>
                    </b-list-group-item>
                  </b-list-group>
                </div>    
              
                <!-- Hod Modal -->
                <b-modal
                id="modal-5"
                ref="modalfive"
                title="Add Hod"
                size="lg"
                no-close-on-esc
                no-close-on-backdrop
                hide-header-close
                hide-footer
                >
                
                <div class="row">
                  <div class="col-md-6 form-group">
                    User Name
                    <input
                      class="form-control"
                      v-model="hodName"
                      @focus="hodNameEmpty = false"
                    />
                    <div class="form-group" style="color: red" v-if="hodNameEmpty">
                      Username is required
                    </div>
                  </div>

                  <div class="col-md-6 form-group" style="position: relative">
                    Password
                    <input
                      id="password"
                      type="password"
                      class="form-control"
                      v-model="hodPassword"
                      @focus="hodPasswordEmpty = false"
                    />
                    <i class="far fa-eye" @click="togglePassword()" id="eyeIcon" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                    <div v-if="hodPasswordEmpty" style="color: red">
                      Password is required
                    </div>
                  </div>
                  <div class="col-md-6 form-group" style="position: relative">
                    Confirm Password
                      <input
                        id="password1"
                        type="password"
                        class="form-control"
                        v-model="hodConfirmPassword"
                        @focus="hodConfirmPasswordEmpty = false,hodConfirmPasswordMatch = false"
                      />
                      <i class="far fa-eye" @click="togglePassword1()" id="eyeIcon1" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                      <div v-if="hodConfirmPasswordEmpty" style="color: red">
                        Confirm Password is required
                      </div>
                      <div v-if="hodConfirmPasswordMatch" style="color: red">
                        Password does not match 
                      </div>
                    </div>
                </div>
                  <b-button
                    @click="addHod()"
                    variant="success"
                    class="float-right ml-2"
                    >Insert</b-button
                  >
                  <b-button
                    @click="cancelButtonHod()"
                    variant="danger"
                    class="float-right"
                    >Cancel</b-button
                  >
                </b-modal>

                <!-- Hod edit modal -->
                <b-modal
                id="modal-6"
                ref="modalsix"
                title="Edit Hod"
                size="lg"
                no-close-on-esc
                no-close-on-backdrop
                hide-header-close
                hide-footer
                >
                <div class="row">
                  <div class="col-md-6 form-group">
                    Usernme
                    <input
                      class="form-control"
                      v-model="hodName"
                      @focus="hodNameEmpty = false"
                    />
                    <div
                      class="form-group"
                      style="color: red"
                      v-if="hodNameEmpty"
                    >
                      Username is required
                    </div>
                  </div>
                  

                  <div class="col-md-6 form-group" style="position: relative">
                    Password
                    <input
                      id="password"
                      type="password"
                      class="form-control"
                      v-model="hodPassword"
                      @focus="hodPasswordEmpty = false"
                    />
                    <i class="far fa-eye" @click="togglePassword()" id="eyeIcon" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                    <div v-if="hodPasswordEmpty" style="color: red">
                      Password is required
                    </div>
                  </div>
                  <div class="col-md-6 form-group" style="position: relative">
                    Confirm Password
                      <input
                        id="password1"
                        type="password"
                        class="form-control"
                        v-model="hodConfirmPassword"
                        @focus="hodConfirmPasswordEmpty = false,hodConfirmPasswordMatch = false"
                      />
                      <i class="far fa-eye" @click="togglePassword1()" id="eyeIcon1" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                      <div v-if="hodConfirmPasswordEmpty" style="color: red">
                        Confirm Password is required
                      </div>
                      <div v-if="hodConfirmPasswordMatch" style="color: red">
                        Password does not match 
                      </div>
                    </div>

                </div>
                <div>
                  <b-button
                    @click="editHod()"
                    variant="success"
                    class="float-right ml-2"
                    >Save changes</b-button
                  >
                  <b-button
                    variant="danger"
                    class="float-right"
                    @click="editHodCancelButton()"
                    >Cancel</b-button
                  >
                </div>
              </b-modal>
            </div>


          



            <!-- Class List-->
              <div class="col-md-6 form-group">
                <b-list-group v-if="addClassButton">
                  Class
                  <b-list-group-item
                    id="addClassButton"
                    v-b-modal.modal-7
                    class="mb-1"
                    button
                    >+ Add Class</b-list-group-item
                  ></b-list-group
                >
                <div style="max-height: 280px; overflow-y: scroll">
                  <b-list-group
                    v-for="(collge_admin, index) in college_admin_class"
                    :key="index"
                    class="mb-1"
                  >
                    <b-list-group-item
                      >{{ collge_admin.username}}
                      <b-btn-group class="float-right"
                        ><b-button
                          size="sm"
                          variant="alt-primary"
                          @click="loadClass(collge_admin.id)"
                          v-b-modal.modal-8
                        >
                          <i class="fa fa-fw fa-pencil-alt"></i>
                        </b-button>                   
                      
                      </b-btn-group>
                    </b-list-group-item>
                  </b-list-group>
                </div>    
              
              <!-- Class Modal -->
              <b-modal
                id="modal-7"
                ref="modalseven"
                title="Add Class"
                size="lg"
                no-close-on-esc
                no-close-on-backdrop
                hide-header-close
                hide-footer
                >
                
                <div class="row">
                  <div class="col-md-6 form-group">
                    User Name
                    <input
                      class="form-control"
                      v-model="className"
                      @focus="classNameEmpty = false"
                    />
                    <div class="form-group" style="color: red" v-if="classNameEmpty">
                      Username is required
                    </div>
                  </div>

                  <div class="col-md-6 form-group" style="position: relative">
                    Password
                    <input
                      id="password"
                      type="password"
                      class="form-control"
                      v-model="classPassword"
                      @focus="classPasswordEmpty = false"
                    />
                    <i class="far fa-eye" @click="togglePassword()" id="eyeIcon" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                    <div v-if="classPasswordEmpty" style="color: red">
                      Password is required
                    </div>
                  </div>
                  <div class="col-md-6 form-group" style="position: relative">
                    Confirm Password
                      <input
                        id="password1"
                        type="password"
                        class="form-control"
                        v-model="classConfirmPassword"
                        @focus="classConfirmPasswordEmpty = false,classConfirmPasswordMatch = false"
                      />
                      <i class="far fa-eye" @click="togglePassword1()" id="eyeIcon1" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                      <div v-if="classConfirmPasswordEmpty" style="color: red">
                        Confirm Password is required
                      </div>
                      <div v-if="classConfirmPasswordMatch" style="color: red">
                        Password does not match 
                      </div>
                    </div>
                </div>
                  <b-button
                    @click="addClass()"
                    variant="success"
                    class="float-right ml-2"
                    >Insert</b-button
                  >
                  <b-button
                    @click="cancelButtonClass()"
                    variant="danger"
                    class="float-right"
                    >Cancel</b-button
                  >
              </b-modal>

              <!-- Class edit modal -->
              <b-modal
                id="modal-8"
                ref="modaleight"
                title="Edit Class"
                size="lg"
                no-close-on-esc
                no-close-on-backdrop
                hide-header-close
                hide-footer
                >
                <div class="row">
                  <div class="col-md-6 form-group">
                    Usernme
                    <input
                      class="form-control"
                      v-model="className"
                      @focus="classNameEmpty = false"
                    />
                    <div
                      class="form-group"
                      style="color: red"
                      v-if="classNameEmpty"
                    >
                      Username is required
                    </div>
                  </div>
                  

                  <div class="col-md-6 form-group" style="position: relative">
                    Password
                    <input
                      id="password"
                      type="password"
                      class="form-control"
                      v-model="classPassword"
                      @focus="classPasswordEmpty = false"
                    />
                    <i class="far fa-eye" @click="togglePassword()" id="eyeIcon" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                    <div v-if="classPasswordEmpty" style="color: red">
                      Password is required
                    </div>
                  </div>
                  <div class="col-md-6 form-group" style="position: relative">
                    Confirm Password
                      <input
                        id="password1"
                        type="password"
                        class="form-control"
                        v-model="classConfirmPassword"
                        @focus="classConfirmPasswordEmpty = false,classConfirmPasswordMatch = false"
                      />
                      <i class="far fa-eye" @click="togglePassword1()" id="eyeIcon1" style="position: relative;bottom: 28px;right: 0px;left: 330px;"></i>
                      <div v-if="classConfirmPasswordEmpty" style="color: red">
                        Confirm Password is required
                      </div>
                      <div v-if="classConfirmPasswordMatch" style="color: red">
                        Password does not match 
                      </div>
                    </div>

                </div>
                <div>
                  <b-button
                    @click="editClass()"
                    variant="success"
                    class="float-right ml-2"
                    >Save changes</b-button
                  >
                  <b-button
                    variant="danger"
                    class="float-right"
                    @click="editClassCancelButton()"
                    >Cancel</b-button
                  >
                </div>
              </b-modal>
          </div>

          </div>
          <!-- Loader -->
          <b-overlay :show="loader" no-wrap blur="2px" opacity="0.60" class="position-fixed">
            <template #overlay>
              <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
            </template>
          </b-overlay>
          <!-- End Loader -->
          
        </base-block>
      <!-- END Full Table -->
      </div>
      <!-- END Page Content -->


      <b-overlay :show="loader" no-wrap blur="2px" opacity="0.60" class="position-fixed">
        <template #overlay>
          <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
        </template>
      </b-overlay>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loader:false,
      nameEmpty: false,
      usernameEmpty: false,
      name: "",
      topicName: "",
      topicEmpty: false,
      username: "",
      password: "",
      passwordEmpty: false,
      confirmpassword: "",
      confirmpasswordEmpty: false,
      confirmpasswordMatch: false,
      subscriptions: [],
      college_director:[],
      departmentPassword: "",
      departmentName: "",
      departmentNameEmpty: false,
      departmentPasswordEmpty: false,
      departmentConfirmPassword: "",
      departmentConfirmPasswordEmpty: false,
      departmentConfirmPasswordMatch: false,
      editHodId: "",
      editClassId: "",
      
      hodPassword: "",
      hodName: "",
      hodNameEmpty: false,
      hodPasswordEmpty: false,
      hodConfirmPassword: "",
      hodConfirmPasswordEmpty: false,
      hodConfirmPasswordMatch: false,


      classPassword: "",
      className: "",
      classNameEmpty: false,
      classPasswordEmpty: false,
      classConfirmPassword: "",
      classConfirmPasswordEmpty: false,
      classConfirmPasswordMatch: false,
      addClassButton: false,

      buttonVariant: "success",
      college_admin_id: "",
      collegeAdminIdEmpty: false,
      
  
      
      editLibraryId: 0,
      editParentTopicId: 0,
      libraryNameEmpty: false,
      addlibraryButton: false,
      parentLibraryName:"",
      libraryName: "",
      parentTopicEmpty: false,
      addHodButton:false,
      parentTopics: [],
      collge_admins: [],
      collge_admin_hods: [],
      college_admin_class: [],
    };
  },
  mounted() {
    this.loadData();
    // this.getParentTopics();
  },
  methods: {
     togglePassword() {
      let passwordField = document.getElementById("password")
      const type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password'
      passwordField.setAttribute("type", type)
      let eyeIcon = document.getElementById("eyeIcon")
      eyeIcon.classList.toggle('fa-eye-slash')
    },

    togglePassword1() {
      let passwordField1 = document.getElementById("password1")
      const type = passwordField1.getAttribute('type') === 'password' ? 'text' : 'password'
      passwordField1.setAttribute("type", type)
      let eyeIcon1 = document.getElementById("eyeIcon1")
      eyeIcon1.classList.toggle('fa-eye-slash')
    },


    async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college/edit/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.id = response.data.college.id;
            this.name = response.data.college.name;
            this.subscriptions = response.data.subscriptions;
            this.college_director = response.data.college_director;
          } else {
            this.$swal("Success", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async toggleStatus(id, index, status) {
      await axios
        .get(`${this.$store.getters.baseUrl}/college/sub-status/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loadData();
            this.subscriptions[index].status = status == 1 ? 0 : 1;
            this.$swal({
              text: `${response.data.message}`,
              icon: status ? "error" : "success",
            });
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async editCollege() {
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }

      this.loader = true;
      const formdata = new FormData();
      formdata.append("name", this.name);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/college/update/${this.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loader = false;
            this.$swal("Success", "College updated successfully", "success");
            this.$router.push({ name: "Colleges" });
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async deleteSub(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/college/sub-edit/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loadData();
            this.$swal(
              "Success",
              "College Subscription deleted successfully",
              "success"
            );
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    
    async parentTopicStatus(id ,index, status) {
      await axios
        .get(`${this.$store.getters.baseUrl}/libraries/status/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.parentTopics[index].status = status == 1 ? 0 : 1
           this.$swal({text:`${response.data.message} successfully`,icon:status?'error':'success'});
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },
    editLibraryCancelButton() {
      this.$refs.modalfour.hide();
      (this.libraryName = ""),
        this.libraryNameEmpty = false;
      (this.departmentPassword = ""),
      (this.departmentConfirmPassword = ""),
        this.departmentPasswordEmpty = false;
        this.departmentConfirmPasswordEmpty = false;
    },
    editHodCancelButton() {
      this.$refs.modalsix.hide();
      (this.hodName = ""),
        this.hodNameEmpty = false;
      (this.hodPassword = ""),
      (this.hodConfirmPassword = ""),
        this.hodPasswordEmpty = false;
        this.hodConfirmPasswordEmpty = false;
    },
    
    editClassCancelButton() {
      this.$refs.modaleight.hide();
      (this.className = ""),
      (this.classPassword = ""),
      (this.classConfirmPassword = ""),
        this.classNameEmpty = false;
        this.classPasswordEmpty = false;
        this.classConfirmPasswordEmpty = false;
    },
    

    async editLibrary() {
      if (this.libraryName == "") {
        this.libraryNameEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("username", this.libraryName);
      formdata.append("college_admin_id", this.college_admin_id);
      formdata.append("password", this.departmentPassword);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/college/admin-edit`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data.status == "success") {
            this.$refs.modalfour.hide();
            console.log(response);
            this.$swal("Success", "Department updated successfully", "success");             
      (this.libraryName = ""),
      (this.departmentPassword = ""),
      (this.departmentConfirmPassword = ""),
      this.$refs.modaltwo.hide();
        this.libraryNameEmpty = false;
        this.departmentPasswordEmpty = false;
        this.departmentConfirmPasswordEmpty = false;     
            this.getDepartments(this.college_director.id);            
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async loadLibrary(id) {
      this.editLibraryId = id;
      await axios
        .get(`${this.$store.getters.baseUrl}/college/admin-view/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.libraryName = response.data.college_admin.username;
            this.college_admin_id = response.data.college_admin.id;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async editParentTopics() {
      if (this.parentLibraryName == "") {
        this.parentTopicEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("username", this.parentLibraryName);
      formdata.append("college_admin_id", this.college_admin_id);
      formdata.append("password", this.password);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/college/admin-edit`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$refs.modalthree.hide();
            console.log(response);
            this.$swal("Success", "Director updated successfully", "success");
            this.loadData();
            
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async loadParentTopic(id) {
      this.editParentTopicId = id;
      await axios
        .get(`${this.$store.getters.baseUrl}/college/admin-view/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.parentLibraryName = response.data.college_admin.username;
            this.college_admin_id = response.data.college_admin.id;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },
    cancelButtonDepartment() {
      (this.libraryName = ""),
      (this.departmentPassword = ""),
      (this.departmentConfirmPassword = ""),
      this.$refs.modaltwo.hide();
        this.libraryNameEmpty = false;
        this.departmentPasswordEmpty = false;
        this.departmentConfirmPasswordEmpty = false;
    },

    
    cancelButtonHod() {
      (this.hodName = ""),
      (this.hodPassword = ""),
      (this.hodConfirmPassword = ""),
      this.$refs.modalfive.hide();
        this.hodNameEmpty = false;
        this.hodPasswordEmpty = false;
        this.hodConfirmPasswordEmpty = false;
    },
    
    cancelButtonClass() {
      (this.className = ""),
      (this.classPassword = ""),
      (this.classConfirmPassword = ""),
        this.classNameEmpty = false;
        this.classPasswordEmpty = false;
        this.classConfirmPasswordEmpty = false;
      this.$refs.modalseven.hide();
    },

    editCancelButtonParentLibrary() {
      this.parentLibraryName = "";
      this.parentTopicEmpty = false;
      (this.password = ""),
      (this.confirmPassword = ""),
      this.passwordEmpty = false;
      this.confirmPasswordEmpty = false;
      this.$refs.modalthree.hide();
    },
    cancelButtonParentData() {
      this.topicName = "";
      (this.password = ""),
      (this.confirmpassword = ""),
      this.passwordEmpty = false;
      this.confirmpasswordEmpty = false;
      this.topicEmpty = false;
      this.$refs.modalone.hide();
    },
    async getDepartments(id) {
      this.addlibraryButton = true;
      await axios
        .get(`${this.$store.getters.baseUrl}/parent/admin-list/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.collge_admins = response.data.collge_admins;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async addParentData() {
      if (this.topicName == "") {
        this.topicEmpty = true;
        return;
      }

      if (this.password == "") {
        this.passwordEmpty = true;
        return;
      }
       if (this.confirmpassword == "") {
        this.confirmpasswordEmpty = true;
        return;
      }
      if(!(this.confirmpassword == this.password)) {
        this.confirmpasswordMatch = true;
        return;
      }
      
      const formdata = new FormData();
      formdata.append("username", this.topicName);
      formdata.append("password", this.password);
      formdata.append("college_id", this.id);
      formdata.append("type", 0);
      await axios
        .post(`${this.$store.getters.baseUrl}/college/admin-add`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$refs.modalone.hide();
            console.log(response);
            this.$swal("Success", "Director added successfully", "success");
            this.loadData();
            this.topicName == "";
            this.password == "";
            this.confirmpassword == "";            
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async addDepartment() {
      if (this.departmentName == "") {
        this.departmentNameEmpty = true;
        return;
      }
      if (this.departmentPassword == "") {
        this.departmentPasswordEmpty = true;
        return;
      }
       if (this.departmentConfirmPassword == "") {
        this.departmentConfirmPasswordEmpty = true;
        return;
      }
      if(!(this.departmentConfirmPassword == this.departmentPassword)) {
        this.departmentConfirmPasswordMatch = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("username", this.departmentName);
      formdata.append("password", this.departmentPassword);
      formdata.append("college_id", this.id);
      formdata.append("type", 1);
      formdata.append("parent_id", this.college_director.id);
      await axios
        .post(`${this.$store.getters.baseUrl}/college/admin-add`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$refs.modaltwo.hide();
            console.log(response);
            this.$swal("Success", "Department added successfully", "success");
            this.departmentName == "";
      (this.departmentName = ""),
        this.departmentNameEmpty = false;
      (this.departmentPassword = ""),
      (this.departmentConfirmPassword = ""),
        this.departmentPasswordEmpty = false;
        this.departmentConfirmPasswordEmpty = false;           
            this.getDepartments(this.college_director.id);
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },



    
    async loadHod(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/college/admin-view/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.hodName = response.data.college_admin.username;
            this.college_admin_id = response.data.college_admin.id;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },
    
    async editHod() {
      if (this.hodName == "") {
        this.hodNameEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("username", this.hodName);
      formdata.append("college_admin_id", this.college_admin_id);
      formdata.append("password", this.hodPassword);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/college/admin-edit`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data.status == "success") {
            this.$refs.modalsix.hide();
            console.log(response);
            this.$swal("Success", "Hod updated successfully", "success");    
      (this.hodName = ""),
        this.hodNameEmpty = false;
      (this.hodPassword = ""),
      (this.hodConfirmPassword = ""),
        this.hodPasswordEmpty = false;
        this.hodConfirmPasswordEmpty = false;        
            this.getHods(this.editHodId);
            
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    
    async addHod() {
      if (this.hodName == "") {
        this.hodNameEmpty = true;
        return;
      }
      if (this.hodPassword == "") {
        this.hodPasswordEmpty = true;
        return;
      }
       if (this.hodConfirmPassword == "") {
        this.hodConfirmPasswordEmpty = true;
        return;
      }
      if(!(this.hodConfirmPassword == this.hodPassword)) {
        this.hodConfirmPasswordMatch = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("username", this.hodName);
      formdata.append("password", this.hodPassword);
      formdata.append("college_id", this.id);
      formdata.append("type", 2);
      formdata.append("parent_id", this.editHodId);
      await axios
        .post(`${this.$store.getters.baseUrl}/college/admin-add`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.$swal("Success", "Hod added successfully", "success");
      (this.hodName = ""),
        this.hodNameEmpty = false;
      (this.hodPassword = ""),
      (this.hodConfirmPassword = ""),
        this.hodPasswordEmpty = false;
        this.hodConfirmPasswordEmpty = false;  
            this.$refs.modalfive.hide();     
            this.getHods(this.editHodId);
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    
    async getHods(id) {
      this.editHodId = id;
      this.addHodButton = true;
      console.log("hod assdf");
      await axios
        .get(`${this.$store.getters.baseUrl}/parent/admin-list/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.collge_admin_hods = response.data.collge_admins;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },




    
    async loadClass(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/college/admin-view/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.className = response.data.college_admin.username;
            this.college_admin_id = response.data.college_admin.id;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },
    
    async editClass() {
      if (this.className == "") {
        this.classNameEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("username", this.className);
      formdata.append("college_admin_id", this.college_admin_id);
      formdata.append("password", this.classPassword);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/college/admin-edit`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data.status == "success") {
            this.$refs.modaleight.hide();
            console.log(response);
            this.$swal("Success", "Class updated successfully", "success");  
      (this.className = ""),
      (this.classPassword = ""),
      (this.classConfirmPassword = ""),
        this.classNameEmpty = false;
        this.classPasswordEmpty = false;
        this.classConfirmPasswordEmpty = false;          
            this.getClass(this.editClassId);
            
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    
    async addClass() {
      if (this.className == "") {
        this.classNameEmpty = true;
        return;
      }
      if (this.classPassword == "") {
        this.classPasswordEmpty = true;
        return;
      }
       if (this.classConfirmPassword == "") {
        this.classConfirmPasswordEmpty = true;
        return;
      }
      if(!(this.classConfirmPassword == this.classPassword)) {
        this.classConfirmPasswordMatch = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("username", this.className);
      formdata.append("password", this.classPassword);
      formdata.append("college_id", this.id);
      formdata.append("type", 3);
      formdata.append("parent_id", this.editClassId);
      await axios
        .post(`${this.$store.getters.baseUrl}/college/admin-add`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$refs.modalseven.hide();
            console.log(response);
            this.$swal("Success", "Class added successfully", "success");
      (this.className = ""),
      (this.classPassword = ""),
      (this.classConfirmPassword = ""),
        this.classNameEmpty = false;
        this.classPasswordEmpty = false;
        this.classConfirmPasswordEmpty = false;
            this.getClass(this.editClassId);
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    
    async getClass(id) {
      this.editClassId = id;
      this.addClassButton = true;
      console.log("class");
      await axios
        .get(`${this.$store.getters.baseUrl}/parent/admin-list/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.college_admin_class = response.data.collge_admins;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },


  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}

Button:focus {
  outline: none;
}

#addParentTopicButton {
  background-color: #e1e6e9;
}

#addLibraryButton {
  background-color: #e1e6e9;
}
#addHodButton {
  background-color: #e1e6e9;
}
#addClassButton {
  background-color: #e1e6e9;
}
</style>

